<template>
  <b-modal
    :id="idModal"
    no-close-on-backdrop
    hide-footer
    size="md"
    body-class="modal-height"
    content-class="customer-modal-content"
    no-fade
    @shown="focusFirstInput"
  >
    <template #modal-header>
      <div class="d-flex align-items-center justify-content-between w-100 px-3">
        <div class="d-flex gap-2">
          <b-button
            variant="outline-light"
            @click="closeModal"
          >
            {{ $t('customerpopup.cancel') }}
          </b-button>
          <b-button
            variant="outline-primary"
            @click="showCustomerList"
          >
            Customer List
          </b-button>
        </div>
        <h5>{{ $t('customerpopup.add-new-customer') }}</h5>
        <b-button
          variant="primary"
          @click="addCustomer"
        >
          {{ $t('customerpopup.done') }}
        </b-button>
      </div>
    </template>

    <b-card
      class="general-info mb-3"
      body-class="p-0"
    >
      <div class="general-info__content">
        <b-form-input
          v-if="!isCustomerNameDisabled"
          ref="firstNameInput"
          v-model="customer.first_name"
          :class="{'is-invalid': !customer.first_name && isSubmit}"
          class="border-bottom"
          :placeholder="$t('customerpopup.first-name') + ' *'"
          @focus="focusedInput = 'first_name'"
        />

        <b-form-input
          v-if="!isCustomerNameDisabled"
          v-model="customer.last_name"
          class="border-bottom"
          :placeholder="$t('customerpopup.last-name')"
          @focus="focusedInput = 'last_name'"
        />

        <div class="d-flex">
          <b-dropdown
            id="country-code-dropdown"
            variant="light"
            class="country-code-dropdown border-bottom border-right"
            no-caret
            menu-class="country-dropdown-menu"
          >
            <template #button-content>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>{{ customer.country_code || selectedCountry.code }}</span>
                <i class="fa fa-caret-down ml-2" />
              </div>
            </template>
            <b-dropdown-item
              v-for="(country, ind) in countryCodes"
              :key="`${ind}_${country.code}`"
              @click="selectCountry(country)"
            >
              <span class="mr-2">{{ country.flag }}</span>
              <span>{{ country.name }} ({{ country.code }})</span>
            </b-dropdown-item>
          </b-dropdown>

          <b-form-input
            ref="phoneInput"
            v-model="phoneBody"
            :class="{'is-invalid': !isValidPhone && isSubmit}"
            type="tel"
            class="border-bottom flex-grow-1"
            :placeholder="$t('customerpopup.phone-number')"
            @input="formatPhoneNumber"
            @focus="focusedInput = 'phone'"
          />
        </div>

        <b-form-input
          v-model="customer.email"
          :class="{'is-invalid': !isValidEmail && isSubmit && customer.email}"
          type="email"
          :placeholder="$t('customerpopup.email')"
          @focus="focusedInput = 'email'"
        />
      </div>
    </b-card>
  </b-modal>
</template>
<script>
  import orderMixin from "../mixins/order/orderMixin";

  const COUNTRIES = [
    { name: "USA", code: "+1", flag: "🇺🇸" },
    { name: "Canada", code: "+1", flag: "🇨🇦" },
    { name: "Portugal", code: "+351", flag: "🇵🇹" },
    { name: "Germany", code: "+49", flag: "🇩🇪" },
    { name: "UK", code: "+44", flag: "🇬🇧" },
    { name: "Turkey", code: "+90", flag: "🇹🇷" },
    { name: "France", code: "+33", flag: "🇫🇷" },
    { name: "Italy", code: "+39", flag: "🇮🇹" },
    { name: "Spain", code: "+34", flag: "🇪🇸" },
    { name: "Netherlands", code: "+31", flag: "🇳🇱" },
    { name: "Belgium", code: "+32", flag: "🇧🇪" },
    { name: "Austria", code: "+43", flag: "🇦🇹" },
    { name: "Switzerland", code: "+41", flag: "🇨🇭" },
    { name: "Sweden", code: "+46", flag: "🇸🇪" },
    { name: "Norway", code: "+47", flag: "🇳🇴" },
    { name: "Denmark", code: "+45", flag: "🇩🇰" },
    { name: "Finland", code: "+358", flag: "🇫🇮" },
    { name: "Ireland", code: "+353", flag: "🇮🇪" },
    { name: "Poland", code: "+48", flag: "🇵🇱" },
    { name: "Greece", code: "+30", flag: "🇬🇷" }
  ];

  export default {
    name: 'CustomerModalSimple',
    mixins: [orderMixin],
    props: {
      index: {
        type: Number,
        default: null
      }
    },
    data () {
      const defaultCountry = COUNTRIES[0];

      return {
        customer: {
          last_name: "",
          country_code: "+1",
          first_name: "",
          vat_number: "",
          phone: "",
          email: "",
        },
        countryCodes: COUNTRIES,
        selectedCountry: defaultCountry,
        phoneBody: '',
        isSubmit: false,
        focusedInput: null
      }
    },
    computed: {
      terminal() {
        return this.$store.getters["config/terminal"];
      },
      isMoloniEnabled() {
        if (!this.terminal || !this.terminal.db_settings) return false;
        const moloniSetting = this.terminal.db_settings.find(s => s.name === 'moloni_invoice_status');
        return moloniSetting && (moloniSetting.value === '1' || moloniSetting.value === '0');
      },
      emailRules() {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !re.test(this.customer.email) && this.customer.email !== "";
      },
      isCustomerNameDisabled() {
        if (!this.terminal?.db_settings) return false;
        const disableName = this.terminal.db_settings.find(s => s.name === 'customer_disable_name');
        const directAdd = this.terminal.db_settings.find(s => s.name === 'add_customer_direct');
        return disableName?.value === 'true' && directAdd?.value === 'true';
      },
      isDirectCustomerEmail() {
        if (!this.terminal || !this.terminal.db_settings) return false;
        const setting = this.terminal.db_settings.find(s => s.name === 'direct_customer_email');
        return setting && setting.value === 'true';
      },
      countryOptions() {
        return this.countryCodes.map(c => ({
          value: c,
          text: `${c.flag} ${c.code}`
        }));
      },
      isValidForm() {
        // Check email validation if email field is shown and has value
        const emailValid = !this.isDirectCustomerEmail || !this.customer.email || this.isValidEmail;

        // If customer_disable_name is true and add_customer_direct is true, only phone is required
        if (this.isCustomerNameDisabled) {
          return !!this.phoneBody && this.isValidPhone && emailValid;
        }
        // Otherwise, name is required, and if phone is provided, it must be valid
        return !!this.customer.first_name && (!this.phoneBody || this.isValidPhone) && emailValid;
      },
      isValidPhone() {
        // If customer_disable_name is true, phone is required so empty is not valid
        if (this.isCustomerNameDisabled && !this.phoneBody) return false;
        if (!this.phoneBody) return true; // Empty is valid when name is required

        const digitsOnly = this.phoneBody.replace(/\D/g, '');

        if (this.selectedCountry.code === '+1') {
          return digitsOnly.length === 10;
        }

        return digitsOnly.length >= 8; // Basic validation for other countries
      },
      phoneValidationState() {
        if (!this.phoneBody) return null;
        return this.isValidPhone ? true : false;
      },
      isValidEmail() {
        if (!this.customer.email) return true; // Empty is valid (optional field)

        // Basic email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(this.customer.email);
      },
      emailValidationState() {
        if (!this.customer.email) return null;
        return this.isValidEmail ? true : false;
      },
      idModal() {
        return this.index ? 'customer-modal-simple-' + this.index : 'customer-modal-simple'
      }
    },
    created() {
      this.$root.$on('set-customer-modal-phone', this.setPhone);
      this.$root.$on('focus-customer-modal-input', this.focusFirstInput);
    },
    beforeDestroy() {
      this.$root.$off('set-customer-modal-phone', this.setPhone);
      this.$root.$off('focus-customer-modal-input', this.focusFirstInput);
    },
    methods: {
      setPhone(phone) {
        if (phone) {
          // Try to match country code
          let matched = false;
          // Sort codes by length desc to match longest prefix first
          const sortedCodes = [...this.countryCodes].sort((a, b) => b.code.length - a.code.length);

          for (const country of sortedCodes) {
            if (phone.startsWith(country.code)) {
              this.selectedCountry = country;
              this.phoneBody = phone.slice(country.code.length);
              // Clean up the body if it has formatting
              this.phoneBody = this.phoneBody.replace(/\D/g, '');
              matched = true;
              break;
            }
          }

          if (!matched) {
            // Assume US/Canada if no + prefix or just digits provided
             const digitsOnly = phone.replace(/\D/g, '');
             // If starts with 1 and length > 10, strip 1
             if (digitsOnly.length > 10 && digitsOnly.startsWith('1')) {
                this.selectedCountry = this.countryCodes.find(c => c.code === '+1');
                this.phoneBody = digitsOnly.slice(1);
             } else {
                this.phoneBody = digitsOnly;
             }
          }

          this.formatPhoneNumber(this.phoneBody);
        }
      },
      selectCountry(country) {
        this.selectedCountry = country;
        this.formatPhoneNumber(this.phoneBody);
      },
      formatPhoneNumber(value) {
        if (!value) {
          this.phoneBody = '';
          return;
        }

        // Remove all non-digit characters
        let digitsOnly = value.replace(/\D/g, '');

        // Only format for US/Canada (+1)
        if (this.selectedCountry.code === '+1') {
           // Format: (XXX) XXX-XXXX
           let formatted = '';
           if (digitsOnly.length > 0) {
             formatted = '(' + digitsOnly.substring(0, 3);
           }
           if (digitsOnly.length >= 3) {
             formatted += ') ' + digitsOnly.substring(3, 6);
           }
           if (digitsOnly.length >= 6) {
             formatted += '-' + digitsOnly.substring(6, 10);
           }
           this.phoneBody = formatted;
        } else {
           this.phoneBody = digitsOnly;
        }
      },
      focusFirstInput() {
        this.$nextTick(() => {
          try {
            // If name is disabled, focus on phone input instead
            if (this.isCustomerNameDisabled) {
              // Focus on phone input using ref
              if (this.$refs.phoneInput) {
                // Bootstrap Vue b-form-input has a focus method
                if (typeof this.$refs.phoneInput.focus === 'function') {
                  this.$refs.phoneInput.focus();
                } else if (this.$refs.phoneInput.$el) {
                  // Fallback: try to find the input element
                  const input = this.$refs.phoneInput.$el.querySelector('input');
                  if (input && typeof input.focus === 'function') {
                    input.focus();
                  }
                }
              }
            } else if (this.$refs.firstNameInput) {
              this.$refs.firstNameInput.focus();
            }
          } catch (error) {
            // Silently fail if focus cannot be set
            console.warn('Could not focus input:', error);
          }
        });
      },
      async addCustomer() {
        if (!this.isValidForm) {
          this.isSubmit = true;
          return;
        }

        let phoneValue = null;
        if (this.phoneBody) {
          const digitsOnly = this.phoneBody.replace(/\D/g, '');
          phoneValue = this.selectedCountry.code + digitsOnly;
        }

        // Generate customer name from phone if name is not set and customer_disable_name is enabled
        let customerName = this.customer.first_name;
        if (this.isCustomerNameDisabled && (!customerName || customerName.trim() === '')) {
          if (phoneValue) {
            const phoneDigits = phoneValue.replace(/\D/g, '');
            const last4Digits = phoneDigits.slice(-4);
            customerName = `Cust.${last4Digits}`;
          }
        }

        const customer = {
          first_name: customerName,
          last_name: null,
          phone: phoneValue,
          email: this.customer.email || null,
          notes: null,
          vat_number: this.customer.vat_number,
          local_id: (new Date).toISOString(),
          addresses: [],
          default_address: null
        };

        // Save locally first so the flow still works if the network call fails.
        this.$store.commit('customers/save', customer);
        this.$emit('get-customers');
        this.$bvModal.hide(this.idModal);
        this.customerInit();

        // Create the customer on the server on the spot and select the saved
        // record (with its real id) so the order references a synced customer.
        let selected = customer;
        try {
          const created = await this.$store.dispatch('customers/createCustomer', customer);
          if (created && created.id) {
            selected = created;
          }
        } catch (error) {
          console.error('Could not create customer on the spot:', error);
        }

        this.$emit('select-customer-after-add', selected);
      },
      customerInit() {
        this.customer = {
          first_name: "",
          phone: "",
          email: "",
          vat_number: "",
        };
        this.phoneBody = '';
        this.selectedCountry = this.countryCodes[0];
        this.isSubmit = false;
      },
      resetForm() {
        this.customer = { first_name: "", last_name: "", email: "", country_code: "+1" };
        this.phoneBody = "";
        this.isSubmit = false;
      },
      closeModal() {
        this.$bvModal.hide(this.idModal);
        this.customerInit();
        this.$emit('close-modal');
      },
      showCustomerList() {
        // Close the simplified customer modal
        this.$bvModal.hide(this.idModal);
        this.customerInit();
        // Open the customer selection modal
        this.$nextTick(() => {
          this.$bvModal.show('select-customer-modal');
        });
      }
    }
  }
</script>

<style>
/* Global style override for this specific modal to allow dropdowns to overflow */
.customer-modal-content,
.customer-modal-content .modal-body,
.customer-modal-content .card,
.customer-modal-content .general-info {
  overflow: visible !important;
}
.country-dropdown-menu {
  z-index: 9999 !important;
  max-height: 300px;
  overflow-y: auto;
}
</style>

<style scoped type="text/css" lang="scss">
  .modal-body .modal-height {
    height: auto !important;
    min-height: 200px;
  }

  .gap-2 {
    gap: 0.5rem;

    > * + * {
      margin-left: 0.5rem;
    }
  }

  .form-control {
    height: 3rem;
    border-radius: 0;
    border-top: initial;
    border-left: initial;
  }

  .general-info {
    padding: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #eee;

    &__content {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .form-control {
        width: 100%;
      }

      .full-width {
        width: 100%;
      }
    }
  }
</style>

